//API currently implemented by dpapp
module.exports = [
    'config',
    'ajax',

    'isApiSupported',

    'getFingerprint',
    'getNetworkType',

    'getUserInfo',
    'login',
    'logout',

    'getCity',
    'getLocationCity',
    'getLocation',

    'share',
    'configShare',

    'openWebview',
    'closeWebview',
    'jumpWebview',

    'setTitle',
    'setNavButtons',

    'store',
    'retrieve',

    'chooseImage',
    'uploadImage',
    'previewImage',
    'downloadImage',

    'publish',
    'subscribe',
    'unsubscribe',

    'setNavigationBarHidden',
    'setBackgroundColor',
    'setBouncesEnabled',
    'setStatusBarStyle',
    'setLLButton',

    'alert',
    'confirm',
    'prompt',

    'sendSMS',
    'getContactList',

    'setPullDown',
    'stopPullDown',

    'pickCity'
  ];



//////////////////
// WEBPACK FOOTER
// ./~/@dp/knb/compiled/dpapp/api.js
// module id = 513
// module chunks = 0